import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import HideAppBar from "../../widgets/header/HideAppBar";
import {
	Container,
	Grid,
} from "@mui/material";
import {FormProvider, useForm} from "react-hook-form";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import useAnagraficaSearch from './utils/useAnagraficaSearch';
import {useHistory} from 'react-router-dom';
import {searchAnagrafica} from "../../../services/AnagraficaServices";
import {AnagraficaContext} from "../../../App";
import {clean, getAccountInfo} from "../../../utils/GenericUtils";
import SearchPaper from "./utils/SearchPaper";
import SearchCardResult from "./utils/SearchCardResult";
import CreaAnagraficaCard from "../carico/anagrafiche/CreaAnagraficaCard";


export const GestionePazienti = () => {
	const classes = BaseStyle();
	const anagraficaContext = useContext(AnagraficaContext);
	const history = useHistory();
	const [pageNumber, setPageNumber] = useState(0);
	const [value, setValue] = useState("");
	const [open, setOpen] = useState(true);
	const methods = useForm({mode: "onChange"})
	const {loadingSearch, errorSearch, anagraficheSearch, hasMoreSearch} = useAnagraficaSearch(value, pageNumber, false);
	const observer = useRef();

	const lastTicketElementRef = useCallback(node => {
		if (loadingSearch) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMoreSearch) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loadingSearch, hasMoreSearch])

	const handleSearch = (event) => {
		setValue(event.target.value);
	}

	const onClickDetail = (anagrafica) => {
		history.push("/gestione/pazienti/" + anagrafica.idSoggetto)
	}

	const onSearch = useCallback(() => {
		if (open) {
			let data = methods.getValues()?.["search"]
			searchAnagrafica(clean(data), anagraficaContext.dispatch);
		}
	}, [methods, open, anagraficaContext.dispatch])

	useEffect(() => {
		setPageNumber(0);
	}, [value])

	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);

	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Ricerca anagrafiche"}/>
				<Container component={"section"} maxWidth={"xl"} style={{paddingTop: 12}}>
					<FormProvider {...methods} >
						<Grid container spacing={3}>

							<SearchPaper value={value} open={open} onSearch={onSearch} handleSearch={handleSearch}
							             setOpen={setOpen}/>

							<Grid item xs={12}>
								<SearchCardResult open={open} onClickDetail={onClickDetail} anagraficheSearch={anagraficheSearch}
								                  errorSearch={errorSearch} loadingSearch={loadingSearch}
								                  lastTicketElementRef={lastTicketElementRef}/>
							</Grid>

							{!getAccountInfo().roles?.includes("ROLE_SP_301_H") && <Grid item xs={12}>
								<CreaAnagraficaCard/>
							</Grid>}
						</Grid>
					</FormProvider>
				</Container>
			</main>
		</React.Fragment>
	);
}
